import '../assets/semantic.css'
import SuiVue from '@pitcher/semantic-ui-vue'
import Vue from 'vue'

Vue.use(SuiVue)
